import React from "react";

import { CategoryTitle } from "~/sdks/LocalContent/components/CategoryTitle";

import type { CategoryKey } from "~/sdks/LocalContent/types";

import * as styles from "./styles";

export function Category({
  categoryKey,
  children,
}: {
  categoryKey: CategoryKey;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={styles.container}
      data-testid="sidebar-category"
      data-category={categoryKey}
    >
      <CategoryTitle categoryKey={categoryKey} className={styles.title} />
      {children}
    </div>
  );
}
